module.exports = __webpack_public_path__ + "static/media/19ESCAP21.93b76360.jpg";